import { render, staticRenderFns } from "./tabAeBookingUICustom.vue?vue&type=template&id=5f9d573c&scoped=true&"
import script from "./tabAeBookingUICustom.vue?vue&type=script&lang=js&"
export * from "./tabAeBookingUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabAeBookingUICustom.vue?vue&type=style&index=0&id=5f9d573c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d573c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9d573c')) {
      api.createRecord('5f9d573c', component.options)
    } else {
      api.reload('5f9d573c', component.options)
    }
    module.hot.accept("./tabAeBookingUICustom.vue?vue&type=template&id=5f9d573c&scoped=true&", function () {
      api.rerender('5f9d573c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabAeBookingUICustom.vue"
export default component.exports